import { render } from "./BaseInfoIcon.vue?vue&type=template&id=10979000"
import script from "./BaseInfoIcon.vue?vue&type=script&lang=js"
export * from "./BaseInfoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__